module.exports = __webpack_public_path__ + "static/media/icon_49.307197ac.svg";